// main.js
import './polyfill'; // ⚠️ 必须是第一个 import！

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

var app = createApp(App)

// 屏蔽错误信息
app.config.errorHandler = () => null;
 
// 屏蔽黄色警告信息
app.config.warnHandler = () => null

app.use(store)
app.use(router)
app.mount('#app')
app.use(ElementPlus, {
  locale: zhCn,
})

